export default "__VITE_ASSET__BAXIqqkB__"